
// DUCKS pattern
import { createAction, createSlice, } from "@reduxjs/toolkit";
import { clearLocalStorage } from "../../devtools/devtoolsState";
const initialState = {
	loading: false,
	error: "",
	userLoginDetails: [],
	userDetail: [],
	levelMapping: {}
};
export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		fetchAllisLoading(state) {
			state.loading = true;
		},

		fetchUserLoginSucceeded(state, action) {
			state.loading = true;
			let { payload } = action;
			state.userDetail.push(action.payload);
			clearLocalStorage();
			localStorage.setItem("user", JSON.stringify(payload.data))
			localStorage.setItem("token", payload.data?.token)
			localStorage.setItem("auth", true)
		},
		fetchUserDetailSave(state, action) {
			state.userDetail = action.payload;
			state.loading = false;
		},
		fetchRoles(state, action) {
			state.roles = action.payload;
		},
		saveOtp(state, action) {
			state.otp = action.payload;
		},
		setLevelMapping(state, action) {
			state.levelMapping = action.payload;
			localStorage.setItem("levelMapping", JSON.stringify(action.payload))
		}
	},
});

export const authActions = {
	loginDispatch: createAction(`${authSlice.name}/login`, (payload) => ({ payload })),
	changePassword: createAction(`${authSlice.name}/change`, (payload) => ({ payload })),
	fetchUserLoginSucceeded: authSlice.actions.fetchUserLoginSucceeded,
	fetchUserLoginFailure: authSlice.actions.fetchUserLoginFailure,
	fetchUserDetail: createAction(`${authSlice.name}/detail`),
	fetchUserDetailSave: authSlice.actions.fetchUserDetailSave,
	setLevelMapping: authSlice.actions.setLevelMapping,
};

export const selectUserLoginLoading = (state) => state.auth.loading;
export const selectUserLoginDetail = (state) => state.auth.userDetail;
export const selectRoles = (state) => state.auth.roles;
export const levelMapping = (state) => state.auth.levelMapping;

export default authSlice.reducer;
